import TabPanel from "../../../components/TabPanel";
import { Box } from "@mui/material";
import SitePackages from "./Boxs/SitePackages/SitePackages";
import UserPackages from "./Boxs/UserPackages/UserPackages";

function PackagesTabs(props) {
  const { packagesTabsValue } = props;

  return (
    <Box component="main">
      <TabPanel value={packagesTabsValue} index={0}>
        <SitePackages />
      </TabPanel>
      <TabPanel value={packagesTabsValue} index={1}>
        <UserPackages />
      </TabPanel>
    </Box>
  );
}

export default PackagesTabs;
